import React from 'react';
import DashboardHeader1 from './header/header1';
import { useLocation } from 'react-router-dom';
import DashboardHeader2 from './header/header2';
import DashboardHeader3 from './header/header3';
import DashboardHeaderAds from './header/headerAds';
// import DashboardHeader3 from "./header/header3";

const DashboardHeader: React.FC = () => {
  const location = useLocation();
  const dynamicSegment = [
    'profile',
    'user-management',
    'accounts',
    'asin-categorization',
    'text-categorization',
    'blacklist-keywords',
  ];
  const pathUsingHeader1 = [
    '360',
    'automation-rules',
    'sellco-ai',
    'insight',
    ...dynamicSegment.map((segment) => `dashboard/${segment}`),
  ];
  const pathUsingHeader2 = ['growth-tracking', 'day-parting', 'ads'];
  const pathUsingHeader3 = ['snap-suite', 'campaign-central'];
  const currentPath = location.pathname.toLowerCase();
  const isHeader1 = pathUsingHeader1.some((path) => currentPath.includes(path)) && !currentPath.includes('/ads');
  const isHeader2 = pathUsingHeader2.some((path) => currentPath.includes(path));
  const isHeader3 = pathUsingHeader3.some((path) => currentPath.includes(path));
  return (
    <div
      className="sticky top-0 z-10"
      style={{
        boxShadow: '0 1px 4px rgba(35, 47, 62, 0.05)',
      }}
    >
      {isHeader1 && <DashboardHeader1 />}
      {currentPath.includes('/ads') && <DashboardHeaderAds />}
      {!currentPath.includes('/ads') && isHeader2 && <DashboardHeader2 />}
      {isHeader3 && <DashboardHeader3 />}
    </div>
  );
};

export default DashboardHeader;
